module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Zulu.html",
      "xml:lang": "en-GB",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To my friend Fred Couderc"), _c('br'), _vm._v("\n      whose giant’s wings taught me to fly"), _c('br'), _vm._v("\n      and his wife, Laurence,"), _c('br'), _vm._v("\n      a nervous glider."), _c('br')]), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zone Libre,"), _c('br'), _vm._v("\n      for the sound—full volume.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6540914","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0001.vue
// module id = 69
// module chunks = 0